// Bibliotecas
import React from 'react';
import ReactDOM from 'react-dom';

import App from './components/App/App'; // Componentes

ReactDOM.render(
  <App />,
  document.getElementById('root')
);